import Rest from "@/api/Rest";
import moment from "moment";

export default class Service {
	static async GetAllFilters(flyerId, storeId, lang) {
		lang = lang === 'fr' ? 'bil' : lang;
		const {data} = await Rest.Get(
			`Pages/${flyerId}/${storeId}/${lang}/AllDropdownItems`,
		)
		return data;
	}

	static async GetFlyerData(storeId, lang, date, aud = null) {
		lang = lang === 'fr' ? 'bil' : lang;
		let url = `flyers/${storeId}/${lang}?date=${moment(date).format("YYYY-MM-DD")}`;
		
		if (aud !== null) {
			url += `&aud=${aud}`;
		}
		
		const {data, error} = await Rest.Get(url);

		if(error) console.log('Landing Page: error:', error);

		return data;
	}

	static async GetFlyerPage(pagesUrl, flyerId, storeId, lang) {
		if (pagesUrl !== null) {
			let { data } = await Rest.Get(pagesUrl);
			return data;
		}
    let { data } = await Rest.Get(`pages/${flyerId}/${storeId}/${lang}/`);
    return data;
	}

	static async LoadConfig(path) {
		return await fetch(path);
	}
}
